/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { UoMDimension, UomListItemDto } from './uom-list-item.dto';

export const UomListItemMapper = entity<UomListItemDto>({
  dimension1: enumeration(UoMDimension),
  dimension2: enumeration(UoMDimension),
  dimension3: enumeration(UoMDimension),
});
